import { AbstractRecorder } from './AbstractRecorder';
export class WebMusicGradeRecorder extends AbstractRecorder {
    constructor(option) {
        super(option);
    }
    workerName() {
        return 'WebMusicGrade';
    }
    postMessageInit() {
        var _a;
        (_a = this.worker) === null || _a === void 0 ? void 0 : _a.postMessage({
            cmd: 'init',
            data: {
                srcSampleRate: this.option.sampleRate,
                mp3BitRate: this.option.sampleRate,
                pitchInfos: this.pitchInfos,
                batch: this.option.batch,
            }
        });
    }
    onMessage(event) {
        var _a;
        if (event.data.cmd === 'getReplayJson') {
            (_a = this.workerHandleGetReplayJson) === null || _a === void 0 ? void 0 : _a.call(this, event.data.data);
        }
    }
    async getReplayJson(partName) {
        return new Promise((resolve, reject) => {
            // timeout reject
            const ti = setTimeout(() => {
                reject(new Error('getReplayJson timeout!'));
            }, 3000);
            this.workerHandleGetReplayJson = (data) => {
                clearTimeout(ti);
                resolve(data);
            };
            this.worker.postMessage({
                cmd: 'getReplayJson',
                data: {
                    partName
                }
            });
        });
    }
}
